module.exports = __webpack_public_path__ + "static/media/win95-logo.4de36c34.ico";